import React from "react";
import md2 from "../styles/middle2.module.css";

const Middle2 = () => {
  return (
    <div className={md2.cover}>
      <div className={md2.body}>
        <img
          src="https://firebasestorage.googleapis.com/v0/b/cdportfolio-95923.appspot.com/o/Frame%2016663.svg?alt=media&token=ee0a0d25-75fa-4c36-815c-29e5893672f1"
          alt="line"
          className={md2.lineimg}
        />
        <div className={md2.innerbody}>
          <div className={md2.side1}>
            <img
              src="https://firebasestorage.googleapis.com/v0/b/cdportfolio-95923.appspot.com/o/Frame%2016665.svg?alt=media&token=0066a4f8-b782-4cc1-aacf-78fd307dca16"
              alt="btc"
              className={md2.btc}
            />
            <h3>
              Niffty major features includes the following but not limited:
            </h3>
            <p>
              A wonderful serenity has taken possession of my entire soul, like
              these sweet mornings of spring which I enjoy with my whole heart.
              I am alone.
            </p>
          </div>
        </div>
        <img
          src="https://firebasestorage.googleapis.com/v0/b/cdportfolio-95923.appspot.com/o/Middle2.png?alt=media&token=181d54e8-c579-49e3-bae6-f2b94b69ca4a"
          alt="phone"
          className={md2.innerimage}
        />
      </div>
      <div className={md2.body}>
        <img
          src="https://firebasestorage.googleapis.com/v0/b/cdportfolio-95923.appspot.com/o/Frame%2016663.svg?alt=media&token=ee0a0d25-75fa-4c36-815c-29e5893672f1"
          alt="line"
          className={md2.lineimg}
        />
        <img
          src="https://firebasestorage.googleapis.com/v0/b/cdportfolio-95923.appspot.com/o/Middle3.png?alt=media&token=cdc3dc82-a21f-470c-9141-7e2c01db5eb2"
          alt="phone"
          className={md2.innerimage}
        />
        <div className={md2.innerbody}>
          <div className={md2.side1}>
            <img
              src="https://firebasestorage.googleapis.com/v0/b/cdportfolio-95923.appspot.com/o/Frame%2016665.svg?alt=media&token=0066a4f8-b782-4cc1-aacf-78fd307dca16"
              alt="btc"
              className={md2.btc}
            />
            <h3>
              Niffty major features includes the following but not limited:
            </h3>
            <p>
              A wonderful serenity has taken possession of my entire soul, like
              these sweet mornings of spring which I enjoy with my whole heart.
              I am alone.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Middle2;
